import { Component } from '@angular/core';
import { NavbarComponent } from '../navbar/navbar.component';
import { RouterLink, RouterModule } from '@angular/router';
import { HomeMainBannerComponent } from './home-main-banner/home-main-banner.component';
import { VisionMissionComponent } from './vision-mission/vision-mission.component';
import { HomeArticleComponent } from './home-article/home-article.component';
import { HowToPublishComponent } from './how-to-publish/how-to-publish.component';
import { HomeProjectComponent } from './home-project/home-project.component';
import { HomeBookComponent } from './home-book/home-book.component';
import { HowToApplyComponent } from './how-to-apply/how-to-apply.component';
import { HomeDonorComponent } from './home-donor/home-donor.component';
import { HomeBlogComponent } from './home-blog/home-blog.component';
import { HomeEventComponent } from './home-event/home-event.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule, NavbarComponent, HomeMainBannerComponent,
    VisionMissionComponent, HomeArticleComponent,
    HowToPublishComponent, HomeProjectComponent, RouterLink
    , HomeBookComponent, HowToApplyComponent, HomeDonorComponent,
  HomeBlogComponent, HomeEventComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

}
